import Label from './Label.vue';

export default Label;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/form/components/components/label/index.ts